const BACKOFFICE_LOCALHOST = 'http://localhost:8006/api/v1/';
 const BACKOFFICE_DEPLOYMENT = 'https://backoffice.ab-panel.com/api/v1/';

export {
  BACKOFFICE_LOCALHOST,
  BACKOFFICE_DEPLOYMENT
};
